import { render, staticRenderFns } from "./AlgorithmOptimize.vue?vue&type=template&id=e5afa082&scoped=true"
import script from "./AlgorithmOptimize.vue?vue&type=script&lang=js"
export * from "./AlgorithmOptimize.vue?vue&type=script&lang=js"
import style0 from "./AlgorithmOptimize.vue?vue&type=style&index=0&id=e5afa082&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5afa082",
  null
  
)

export default component.exports